import { render, staticRenderFns } from "./accept-call-icon.vue?vue&type=template&id=13a2c8a6"
import script from "./accept-call-icon.vue?vue&type=script&lang=js"
export * from "./accept-call-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports